import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
var _METRIC_MAP;
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.set.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.from.js";
import { COUNTER_METRIC_TYPE, GAUGE_METRIC_TYPE, DISTRIBUTION_METRIC_TYPE, SET_METRIC_TYPE } from './constants.js';
import { simpleHash } from './utils.js';

/**
 * A metric instance representing a counter.
 */
var CounterMetric = /*#__PURE__*/function () {
  function CounterMetric(_value) {
    _classCallCheck(this, CounterMetric);
    this._value = _value;
  }

  /** @inheritDoc */
  _createClass(CounterMetric, [{
    key: "weight",
    get: function get() {
      return 1;
    }

    /** @inheritdoc */
  }, {
    key: "add",
    value: function add(value) {
      this._value += value;
    }

    /** @inheritdoc */
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this._value);
    }
  }]);
  return CounterMetric;
}();
/**
 * A metric instance representing a gauge.
 */
var GaugeMetric = /*#__PURE__*/function () {
  function GaugeMetric(value) {
    _classCallCheck(this, GaugeMetric);
    this._last = value;
    this._min = value;
    this._max = value;
    this._sum = value;
    this._count = 1;
  }

  /** @inheritDoc */
  _createClass(GaugeMetric, [{
    key: "weight",
    get: function get() {
      return 5;
    }

    /** @inheritdoc */
  }, {
    key: "add",
    value: function add(value) {
      this._last = value;
      if (value < this._min) {
        this._min = value;
      }
      if (value > this._max) {
        this._max = value;
      }
      this._sum += value;
      this._count++;
    }

    /** @inheritdoc */
  }, {
    key: "toString",
    value: function toString() {
      return "".concat(this._last, ":").concat(this._min, ":").concat(this._max, ":").concat(this._sum, ":").concat(this._count);
    }
  }]);
  return GaugeMetric;
}();
/**
 * A metric instance representing a distribution.
 */
var DistributionMetric = /*#__PURE__*/function () {
  function DistributionMetric(first) {
    _classCallCheck(this, DistributionMetric);
    this._value = [first];
  }

  /** @inheritDoc */
  _createClass(DistributionMetric, [{
    key: "weight",
    get: function get() {
      return this._value.length;
    }

    /** @inheritdoc */
  }, {
    key: "add",
    value: function add(value) {
      this._value.push(value);
    }

    /** @inheritdoc */
  }, {
    key: "toString",
    value: function toString() {
      return this._value.join(':');
    }
  }]);
  return DistributionMetric;
}();
/**
 * A metric instance representing a set.
 */
var SetMetric = /*#__PURE__*/function () {
  function SetMetric(first) {
    _classCallCheck(this, SetMetric);
    this.first = first;
    this._value = new Set([first]);
  }

  /** @inheritDoc */
  _createClass(SetMetric, [{
    key: "weight",
    get: function get() {
      return this._value.size;
    }

    /** @inheritdoc */
  }, {
    key: "add",
    value: function add(value) {
      this._value.add(value);
    }

    /** @inheritdoc */
  }, {
    key: "toString",
    value: function toString() {
      return Array.from(this._value).map(function (val) {
        return typeof val === 'string' ? simpleHash(val) : val;
      }).join(':');
    }
  }]);
  return SetMetric;
}();
var METRIC_MAP = (_METRIC_MAP = {}, _defineProperty(_METRIC_MAP, COUNTER_METRIC_TYPE, CounterMetric), _defineProperty(_METRIC_MAP, GAUGE_METRIC_TYPE, GaugeMetric), _defineProperty(_METRIC_MAP, DISTRIBUTION_METRIC_TYPE, DistributionMetric), _defineProperty(_METRIC_MAP, SET_METRIC_TYPE, SetMetric), _METRIC_MAP);
export { CounterMetric, DistributionMetric, GaugeMetric, METRIC_MAP, SetMetric };